export const logFeatureEngaged = (category: string, action: string): void => {
  if (typeof window === 'undefined') return;

  import('@netflix/nfa-logger/lib/helper')
    .then(({ nfa }) => {
      nfa.logFeatureEngaged(category, action);
    })
    .catch(() => {
      // Intentionally swallowed — analytics must not break the UI.
    });
};
